

import { useConsumption } from '../../../hooks'
import { createList } from '../../../../../common/utils/graph.utils'
import { formatDateByPeriod } from '../../../../../common/utils/dateFormatter'
import ChartLoaderView from '../../../../../common/components/molecule/Chart/ChartLoaderView/ChartLoaderView'
import ChartLineView from '../../../../../common/components/molecule/Chart/ChartLineView/ChartLineView'




export default function ChartPresenter() {
    const {consunptionQuery, filter, } = useConsumption()
    
    if(consunptionQuery.isLoading) {
        return <ChartLoaderView />
    }
    if(consunptionQuery.isError && consunptionQuery.error) {
      const error = consunptionQuery.error as Error

      return <div>Error occure {error.message}</div>
  }

  const dataChart = createList(filter.aggregateWindow || '1mo', filter, consunptionQuery.data)

  return (
    <ChartLineView
      xAxisData ={dataChart.listx.map((item) => formatDateByPeriod(item, filter.aggregateWindow || '1mo'))}
      data ={dataChart.listValue}
      label='Consommation (kWh)'
      unit='kwh'

    />
  )
}

export interface ResultConverter {
    xAxisData: string[];
    data: number[];

}









